import { useCallback, useEffect, useState } from 'react';
import { getMapLayers } from '../services/api';

const STORAGE_KEY = 'sila_map_layers_state';

const readStored = () => {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
  } catch (error) {
    return {};
  }
};

export const useMapLayers = (enabled = true) => {
  const [layers, setLayers] = useState([]);
  const [defaultSource, setDefaultSource] = useState('');
  const [state, setState] = useState(readStored);

  const reload = useCallback(async () => {
    try {
      const data = await getMapLayers();
      setLayers(data.layers || []);
      setDefaultSource(data.default_source || '');
    } catch (error) {
      setLayers([]);
    }
  }, []);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }, [state]);

  const isActive = (layer) => (state[layer.id]?.active ?? layer.enabled_default);
  const opacityOf = (layer) => (state[layer.id]?.opacity ?? layer.opacity ?? 0.8);
  const toggle = (layer) => setState((prev) => ({ ...prev, [layer.id]: { ...prev[layer.id], active: !isActive(layer) } }));
  const setOpacity = (layer, value) => setState((prev) => ({ ...prev, [layer.id]: { ...prev[layer.id], opacity: value } }));

  const activeLayers = layers.filter(isActive).map((layer) => ({ ...layer, opacity: opacityOf(layer) }));

  return { layers, activeLayers, defaultSource, isActive, opacityOf, toggle, setOpacity, reload };
};
